import React, { useState } from "react";
import { Card, Typography, Table, Pagination, message } from "antd";
import { useParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";
import useCommonListing from "../../../../components/AdminComponents/customHooks/useCommonListing";
import { GetFormattedDateTime } from "../../../../components/utils/DateTimeUtils";

const { Title } = Typography;

const Departments = (props) => {
  const userInfo = useSelector((state) => state.user);
  const { id } = useParams();
  const location = useLocation();
  const isBundle = location.pathname.includes("bundles");
  const isPath = location.pathname.includes("learning-path");
  const [loadAgain, setLoadAgain] = useState(false);

  // Set up common listing hook - dynamically switch between course, bundle, and path endpoints
  let passURL = "";
  let displayTitle = "Course Departments";

  if (isBundle) {
    // bundle_department
    // passURL = `/learn/bundledepartments/${id}/`;
    displayTitle = "Bundle Departments";
  } else if (isPath) {
    // passURL = `/learn/learningpathdepartments/${id}/`;
    displayTitle = "Path Departments";
  } else {
    passURL = `/learn/coursedepartments/${id}/`;
    displayTitle = "Course Departments";
  }

  const {
    data,
    itemsLength,
    loading,
    filterData,
    onShowSizeChange,
    onPageChange,
    handleSearchChange,
  } = useCommonListing({
    passSize: 10,
    passPage: 1,
    passURL: passURL,
    loadAgain: loadAgain,
  });

  const { pageSize, currentPage } = filterData;

  const columns = [
    {
      title: "Department ID",
      dataIndex: "department",
      key: "department",
      width: 140,
    },
    {
      title: "Department Name",
      dataIndex: "department_name",
      key: "department_name",
      width: 250,
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      width: 150,
      render: (date) => date ? date.split('T')[0] : "—",
    },
  ];

  return (
    <Card style={{ width: "100%", marginBottom: "10px" }} hoverable>
      <Title level={5} style={{ marginInline: "10px" }}>
        {displayTitle}
      </Title>

      <CommonTopDetails
        title="Departments"
        titleSuffix={`${itemsLength || 0} department(s)`}
        searchPlaceholder="Search departments..."
        searchAction={handleSearchChange}
        showAddButton={props?.ImpersonateAccess}
        filterAction={false}
        marginPass="15px"
        paddingInlinepass="10px"
        topSizeAdd="5px"
        addButtonProps={{

        }}
      />

      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        size="small"
        loading={loading}
        className="table-container"
        style={{ margin: "1rem" }}
        pagination={false}
        bordered
        scroll={{ x: 600 }}
      />

      <div style={{ display: "flex", justifyContent: "flex-end", padding: "1rem" }}>
        <Pagination
          size="small"
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          onChange={onPageChange}
          pageSizeOptions={["5", "10", "15", "20", "50"]}
          current={currentPage}
          defaultPageSize={pageSize}
          total={itemsLength}
        />
      </div>
    </Card>
  );
};

export default Departments;
